import React from 'react';
import { CloudLightning, BellRing, Sparkles, Droplets } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const ICONS = [CloudLightning, BellRing, Sparkles, Droplets];

export const Pain = () => {
  const { t } = useLanguage();

  return (
    <section id="pain" data-testid="pain-section" className="py-16 md:py-20 bg-sand-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="text-xs uppercase tracking-[0.24em] text-sand-600 mb-6">{t.pain.eyebrow}</div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ink-900 leading-[1.1] mb-6">
              {t.pain.title}
            </h2>
            <p className="text-base md:text-lg text-ink-500 leading-relaxed">
              {t.pain.intro}
            </p>
          </div>

          <div className="lg:col-span-7 space-y-5">
            {t.pain.worries.map((w, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div
                  key={i}
                  data-testid={`pain-card-${i}`}
                  className="group flex items-start gap-5 p-6 md:p-7 bg-cream border border-sand-200 rounded-sm hover:border-sand-400 hover:-translate-y-0.5 transition-all duration-300"
                >
                  <div className="w-11 h-11 shrink-0 rounded-full bg-terracotta-200/40 text-terracotta-500 flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-serif text-xl md:text-2xl text-ink-900 mb-2 leading-snug">{w.title}</h3>
                    <p className="text-sm md:text-base text-ink-500 leading-relaxed">{w.body}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pain;
